:host {
  display: flex;
  flex-direction: row;
  pointer-events: none;
}

:host > * > * {
  pointer-events: all;
}

:host > :nth-child(2).has-content{
  display:flex;
  height: 100%;
  width: 48px;
  z-index: 2;
  position: relative;
}

:host > :nth-child(3).has-content{
  flex: 1 1 100%;
  display:flex;
  height: 100%;
  width: 100%;
}

:host > :nth-child(4).has-content{
  flex: 1 1 48px;
  display:flex;
  height: 100%;
  width: 100%;
}